import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { allGames as seedOld, newGames as seedNew, popularSearches as seedSearches, DOWNLOAD_URL, TELEGRAM_LINK } from "../mock";

export const API = process.env.REACT_APP_BACKEND_URL;

const DataContext = createContext(null);

const fallback = {
  settings: { siteName: "Maha Games Apps", downloadUrl: DOWNLOAD_URL, telegramLink: TELEGRAM_LINK, popularSearches: seedSearches, content: {}, reviews: [], favicon: "/images/games/maha-games-logo-w128.webp", logo: "/images/games/maha-games-logo-w128.webp" },
  games: [...seedOld.map((g, i) => ({ ...g, list: "old", order: i })), ...seedNew.map((g, i) => ({ ...g, list: "new", order: i }))],
};

export const resolveUrl = (u) => (u && u.startsWith("/api/") ? `${API}${u}` : u);
export const safeUrl = (u) => (typeof u === "string" && /^https?:\/\//i.test(u.trim()) ? u.trim() : "");

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);

  const reload = async () => {
    try {
      const { data: d } = await axios.get(`${API}/api/public/bootstrap`);
      setData(d);
    } catch {
      setData(fallback);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  const value = useMemo(() => {
    const d = data || fallback;
    const games = d.games.map((g) => ({ ...g, logo: resolveUrl(g.logo) }));
    const allGames = games.filter((g) => g.list === "old").sort((a, b) => a.order - b.order);
    const newGames = games.filter((g) => g.list === "new").sort((a, b) => a.order - b.order);
    const bySlug = {};
    [...newGames, ...allGames].forEach((g) => { bySlug[g.slug] = g; });
    const settings = { ...fallback.settings, ...d.settings, content: { ...(d.settings?.content || {}) } };
    return {
      loaded: !!data,
      settings,
      allGames,
      newGames,
      popularSearches: settings.popularSearches || [],
      downloadUrl: safeUrl(settings.downloadUrl),
      telegramLink: safeUrl(settings.telegramLink),
      logo: resolveUrl(settings.logo),
      favicon: resolveUrl(settings.favicon),
      getGameBySlug: (slug) => bySlug[slug] || null,
      gameDownloadUrl: (g) => safeUrl(g?.downloadUrl) || safeUrl(settings.downloadUrl),
      reload,
    };
  }, [data]);

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);
